import {
  FETCH_JOB_APPLICATION_LIST,
  FETCH_JOB_APPLICATION_LIST_SUCCESS,
  FETCH_JOB_APPLICATION_LIST_FAILURE,
  CREATE_JOB_APP_CUSTOM_VIEW,
  CREATE_JOB_APP_CUSTOM_VIEW_SUCCESS,
  CREATE_JOB_APP_CUSTOM_VIEW_FAILURE,
  FETCH_JOB_APP_CUSTOM_VIEW,
  FETCH_JOB_APP_CUSTOM_VIEW_SUCCESS,
  FETCH_JOB_APP_CUSTOM_VIEW_FAILURE,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  UNSELECT_JOB_APP_CUSTOM_VIEW,
  UNSELECT_JOB_APP_CUSTOM_VIEW_SUCCESS,
  UNSELECT_JOB_APP_CUSTOM_VIEW_FAILURE,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID_SUCCESS,
  UPDATE_JOB_APPLICATION_STATUS_BY_ID_FAILURE,
  REJECT_JOB_APPLICATION_BY_ID,
  REJECT_JOB_APPLICATION_BY_ID_SUCCESS,
  REJECT_JOB_APPLICATION_BY_ID_FAILURE,
  FETCH_CANDIDATE_ID_BY_EMAIL,
  FETCH_CANDIDATE_ID_BY_EMAIL_SUCCESS,
  FETCH_CANDIDATE_ID_BY_EMAIL_FAILURE,
  RESET_JOB_APPLICATION_LIST,
  SET_JOB_APP_DEFAULT_CUSTOM_VIEW,
  DELETE_JOB_APP_DEFAULT_CUSTOM_VIEW,
  RESET_JOB_APP_CUSTOM_VIEW,
  SET_LOADING,
  SET_APPROVE_ACTION,
  SET_APPROVE_SUCCESS,
  SET_CANDIDATE_ID
} from "./actionTypes";

export const fetchJobApplicationList = (params) => ({
  type: FETCH_JOB_APPLICATION_LIST,
  payload: params,
});

export const fetchJobApplicationListSuccess = (jobApplications) => ({
  type: FETCH_JOB_APPLICATION_LIST_SUCCESS,
  payload: jobApplications,
});

export const fetchJobApplicationListFailure = (error) => ({
  type: FETCH_JOB_APPLICATION_LIST_FAILURE,
  payload: error,
});

export const createJobAppCustomView = (jobAppCustomViewRequest) => ({
  type: CREATE_JOB_APP_CUSTOM_VIEW,
  payload: jobAppCustomViewRequest,
});

export const createJobAppCustomViewSuccess = (jobAppCustomView) => ({
  type: CREATE_JOB_APP_CUSTOM_VIEW_SUCCESS,
  payload: jobAppCustomView,
});

export const createJobAppCustomViewFailure = (error) => ({
  type: CREATE_JOB_APP_CUSTOM_VIEW_FAILURE,
  payload: error,
});

export const fetchJobAppCustomView = () => ({
  type: FETCH_JOB_APP_CUSTOM_VIEW,
});

export const fetchJobAppCustomViewSuccess = (jobAppCustomViews) => ({
  type: FETCH_JOB_APP_CUSTOM_VIEW_SUCCESS,
  payload: jobAppCustomViews,
});

export const fetchJobAppCustomViewFailure = (error) => ({
  type: FETCH_JOB_APP_CUSTOM_VIEW_FAILURE,
  payload: error,
});

export const deleteJobAppCustomViewById = (jobAppCustomViewRequest) => ({
  type: DELETE_JOB_APP_CUSTOM_VIEW_BY_ID,
  payload: jobAppCustomViewRequest,
});

export const deleteJobAppCustomViewByIdSuccess = (jobAppCustomView) => ({
  type: DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: jobAppCustomView,
});

export const deleteJobAppCustomViewByIdFailure = (error) => ({
  type: DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const fetchJobAppCustomViewById = (jobAppCustomViewId) => ({
  type: FETCH_JOB_APP_CUSTOM_VIEW_BY_ID,
  payload: jobAppCustomViewId,
});

export const fetchJobAppCustomViewByIdSuccess = (jobAppCustomView) => ({
  type: FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: jobAppCustomView,
});

export const fetchJobAppCustomViewByIdFailure = (error) => ({
  type: FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const selectJobAppCustomViewById = (jobAppCustomViewRequest) => ({
  type: SELECT_JOB_APP_CUSTOM_VIEW_BY_ID,
  payload: jobAppCustomViewRequest,
});

export const selectJobAppCustomViewByIdSuccess = (jobAppCustomView) => ({
  type: SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: jobAppCustomView,
});

export const selectJobAppCustomViewByIdFailure = (error) => ({
  type: SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const unselectJobAppCustomView = () => ({
  type: UNSELECT_JOB_APP_CUSTOM_VIEW,
});

export const unselectJobAppCustomViewSuccess = () => ({
  type: UNSELECT_JOB_APP_CUSTOM_VIEW_SUCCESS,
});

export const unselectJobAppCustomViewFailure = (error) => ({
  type: UNSELECT_JOB_APP_CUSTOM_VIEW_FAILURE,
  payload: error,
});

export const editJobAppCustomViewById = (jobAppCustomViewRequest) => ({
  type: EDIT_JOB_APP_CUSTOM_VIEW_BY_ID,
  payload: jobAppCustomViewRequest,
});

export const editJobAppCustomViewByIdSuccess = (jobAppCustomView) => ({
  type: EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: jobAppCustomView,
});

export const editJobAppCustomViewByIdFailure = (error) => ({
  type: EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const updateJobApplicationStatusById = (data) => ({
  type: UPDATE_JOB_APPLICATION_STATUS_BY_ID,
  payload: data,
});

export const updateJobApplicationStatusByIdSuccess = (jobApplication) => ({
  type: UPDATE_JOB_APPLICATION_STATUS_BY_ID_SUCCESS,
  payload: jobApplication,
});

export const updateJobApplicationStatusByIdFailure = (error) => ({
  type: UPDATE_JOB_APPLICATION_STATUS_BY_ID_FAILURE,
  payload: error,
});

export const rejectJobApplicationById = (data) => ({
  type: REJECT_JOB_APPLICATION_BY_ID,
  payload: data,
});

export const rejectJobApplicationByIdSuccess = () => ({
  type: REJECT_JOB_APPLICATION_BY_ID_SUCCESS,
});

export const rejectJobApplicationByIdFailure = (error) => ({
  type: REJECT_JOB_APPLICATION_BY_ID_FAILURE,
  payload: error,
});

export const fetchCandidateIdByEmail = (email) => ({
  type: FETCH_CANDIDATE_ID_BY_EMAIL,
  payload: email,
});

export const fetchCandidateIdByEmailSuccess = (candidateId) => ({
  type: FETCH_CANDIDATE_ID_BY_EMAIL_SUCCESS,
  payload: candidateId,
});

export const fetchCandidateIdByEmailFailure = (error) => ({
  type: FETCH_CANDIDATE_ID_BY_EMAIL_FAILURE,
  payload: error,
});

export const resetJobApplicationList = () => ({
  type: RESET_JOB_APPLICATION_LIST,
});

export const setJobAppDefaultCustomView = (jobAppCustomViewRequest) => ({
  type: SET_JOB_APP_DEFAULT_CUSTOM_VIEW,
  payload: jobAppCustomViewRequest,
});

export const deleteJobAppDefaultCustomView = () => ({
  type: DELETE_JOB_APP_DEFAULT_CUSTOM_VIEW,
});

export const resetJobAppCustomView = () => ({
  type: RESET_JOB_APP_CUSTOM_VIEW,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setApproveAction = (action) => ({
  type: SET_APPROVE_ACTION,
  payload: action,
});

export const setApproveSuccess = (success) => ({
  type: SET_APPROVE_SUCCESS,
  payload: success,
});

export const setCandidateId = (candidateId) => ({
  type: SET_CANDIDATE_ID,
  payload: candidateId,
});